export default __webpack_public_path__ + "static/media/left.32256eba.jpg";